import { useState,useEffect } from "react";
import ItemList from "./ItemList";
import { PacmanLoader } from "react-spinners";
import { useParams } from 'react-router-dom'
import { db } from '../../firebase/firebase'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { useAuth } from "../context/AuthContext";

const ItemListContainer = ({greeting}) => {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)

  const { categoryName } = useParams()

  const { user, logout, loadingUser } = useAuth()

  const handleLogOut = async () =>{
    try {
      await logout()
    } catch (error) {
      console.error(error);
    }
  }


  useEffect(()=>{
    const getFirestoreProducts = async() =>{
      try {
        const productsCollection = collection(db, 'productos')
        const q = categoryName ? query(productsCollection, where('category', '==', categoryName)) : productsCollection
        const response = await getDocs(q)
        const productsList = response.docs.map( doc => {
          return {
            id: doc.id,
            ...doc.data()
          }
        })
        setProducts(productsList)
        setLoading(false)
      } catch (error) {
        console.error(error);
      }
    }
    getFirestoreProducts()
    
  },[categoryName]) 

  if (loadingUser) return <PacmanLoader cssOverride={{margin: '0 auto', marginTop: '1rem'}}/>

  return (
    <>
      <h1 className="mt-5 text-4xl text-center ">{greeting} {categoryName} <br /> {!categoryName && (user.displayName ? user.displayName : user.email)}</h1>

      {!categoryName && <button onClick={handleLogOut} className='block px-4 py-2 mx-auto mt-5 text-white border rounded-md bg-slate-600 hover:opacity-90 '>Desconectarse</button>}

      {loading ? <PacmanLoader cssOverride={{margin: '0 auto', marginTop: '1rem'}}/> : <ItemList products={products} />}
    </>
  )
}

export default ItemListContainer
